(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elite-sticky-product-action"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elite-purchase-help')) {
    customElements.define('elite-purchase-help', class extends HTMLElement {
      connectedCallback() {
        this.info = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
        if (!this.info) return;
        this.bar = this.querySelector('[data-elite-sticky-product]');
        this.button = this.querySelector('[data-elite-sticky-submit]');
        this.spacer = this.previousElementSibling;
        let initialVariant;
        try { initialVariant = JSON.parse(this.info.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch { initialVariant = null; }
        const cameFromDirectLink = Boolean(initialVariant?.id) && new URLSearchParams(location.search).get('variant') === String(initialVariant.id);
        this.confirmedGroups = new Set();
        if (cameFromDirectLink) this.requiredGroups().forEach((group) => this.confirmedGroups.add(this.groupName(group)));
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        };
        this.button.addEventListener('click', () => {
          if (this.requiresConfirmation()) this.focusGroup();
          else this.mainButton()?.click();
        }, options);
        this.info.addEventListener('click', (event) => {
          const group = this.requiredGroups().find((g) => g.contains(event.target) && event.target.closest('input, label'));
          if (group) {
            this.confirmedGroups.add(this.groupName(group));
            this.schedule();
          }
          if (event.target.closest('[type="submit"]') && this.requiresConfirmation()) {
            event.preventDefault(); event.stopImmediatePropagation(); this.focusGroup();
          }
        }, { ...options, capture: true });
        this.info.addEventListener('change', (event) => {
          const group = this.requiredGroups().find((g) => g.contains(event.target));
          if (group) this.confirmedGroups.add(this.groupName(group));
          this.schedule();
        }, options);
        this.info.addEventListener('submit', (event) => {
          if (event.target.matches('form[action*="/cart/add"]') && this.requiresConfirmation()) {
            event.preventDefault(); event.stopImmediatePropagation(); this.focusGroup();
          }
        }, { ...options, capture: true });
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('resize', this.schedule, options);
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.info, { subtree: true, childList: true, attributes: true });
        this.overlayObserver = new MutationObserver(this.schedule);
        this.overlayObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
        this.sync();
      }
      mainButton() { return this.info.querySelector('product-form form[action*="/cart/add"] [type="submit"]'); }
      groupName(group) {
        return (group.querySelector('legend, .form__label')?.textContent.trim() || '').toLowerCase();
      }
      requiredGroups() {
        return [...this.info.querySelectorAll('variant-selects .product-form__input')].filter((group) => {
          const name = this.groupName(group);
          return /^(?:uk\s+|shoe\s+)?(size|fit|heel)\b/i.test(name) && group.querySelectorAll('input[type="radio"], option').length > 1;
        });
      }
      firstUnconfirmedGroup() {
        return this.requiredGroups().find((group) => !this.confirmedGroups.has(this.groupName(group)));
      }
      requiresConfirmation() { return Boolean(this.firstUnconfirmedGroup()); }
      focusGroup() {
        const group = this.firstUnconfirmedGroup();
        if (!group) return;
        group.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        group.querySelector('input:checked, select, input')?.focus({ preventScroll: true });
      }
      sync() {
        const main = this.mainButton();
        if (!main) { this.bar.hidden = true; return; }
        const required = this.requiresConfirmation();
        if (this.info.hasAttribute('data-elite-size-required') !== required) this.info.toggleAttribute('data-elite-size-required', required);
        const label = main.querySelector('span:not(.loading__spinner)');
        if (label && required && !main.disabled && label.textContent.trim() !== this.dataset.chooseSize) label.textContent = this.dataset.chooseSize;
        else if (label && !required && label.textContent.trim() === this.dataset.chooseSize) label.textContent = this.dataset.addToCart;
        let prompt = this.info.querySelector('[data-elite-size-prompt]');
        if (required && !prompt) {
          prompt = document.createElement('p'); prompt.dataset.eliteSizePrompt = ''; prompt.className = 'elite-size-prompt';
          prompt.textContent = this.dataset.chooseSize; prompt.setAttribute('role', 'status');
          this.firstUnconfirmedGroup()?.before(prompt);
        } else if (prompt && !required) prompt.remove();
        this.button.disabled = (main.disabled || main.getAttribute('aria-disabled') === 'true') && !required;
        this.button.textContent = required ? this.dataset.chooseSize : label?.textContent.trim() || this.dataset.addToCart;
        const selected = this.info.querySelector('variant-selects [data-selected-variant]');
        let variant;
        try { variant = JSON.parse(selected?.textContent || 'null'); } catch { variant = null; }
        this.querySelector('[data-elite-sticky-options]').textContent = required ? this.dataset.chooseSize : variant?.options?.join(' / ') || '';
        const priceRoot = this.info.querySelector('[id^="price-"]');
        const price = priceRoot?.querySelector('.price--on-sale .price__sale .price-item--sale') || priceRoot?.querySelector('.price__regular .price-item--regular');
        this.querySelector('[data-elite-sticky-price]').textContent = priceRoot?.classList.contains('hidden') ? '' : price?.textContent.trim() || '';
        const overlay = document.querySelector('cart-drawer.active, .cart-notification.active, modal-dialog[open], product-modal[open], menu-drawer details[open], details-modal details[open]');
        const show = matchMedia('(max-width: 749px)').matches && main.getBoundingClientRect().bottom < 0 && !overlay;
        this.bar.hidden = !show;
        this.spacer.hidden = !show;
      }
      disconnectedCallback() {
        this.abort?.abort(); this.observer?.disconnect(); this.overlayObserver?.disconnect(); cancelAnimationFrame(this.frame);
        this.info?.removeAttribute('data-elite-size-required');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
